import {Component, OnDestroy} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import {Subject, of} from 'rxjs';
import { takeUntil, combineLatestAll} from 'rxjs/operators';
import {
    MxDynamicFormService,
    MxFormCustomizerEvent, MxFormErrorMessageService,
    MxPreloaderService,
    OnBoFormReady,
    UiDataObj,
    withPreloader
} from 'mx-core';
import { PrlTranslateService } from '../../../../shared/services/prl-translate.service';
import { PrlAccountDataService } from '../../../prl-dashboard/services/account/prl-account-data.service';
import {FormGroup} from '@angular/forms';
import {PrlProfilesDataService} from '../../services/prl-profiles-data.service';

@Component({
    selector: 'prl-profile-add',
    template: `<mx-object-form (customize)="onCustomize($event)"></mx-object-form>`,
    standalone: false
})
export class PrlProfileAddComponent implements OnDestroy, OnBoFormReady {

    private _destroy$$: Subject<null> = new Subject<null>();
    private form: FormGroup;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private location: Location,
        private translateService: PrlTranslateService,
        private dynamicFormService: MxDynamicFormService,
        private preloader: MxPreloaderService,
        private accountDataService: PrlAccountDataService,
        private prlProfilesCampaignDataService: PrlProfilesDataService,
        private errorService: MxFormErrorMessageService
    ) {}


    ngOnDestroy(): void {
        this._destroy$$.next(null);
    }

    onCustomize(event: MxFormCustomizerEvent): void {
        event.fieldsData.next({
            objectMetaSource: null,
            initialData: {}
        });

        event.customizeProps({addPrefixToTitle: false})
            .customizeFormMode('new')
            .customizeBoFormConfig({title: this.translateService.getTranslatedLabel('label.profiles.create.new')})

        of(
            this.dynamicFormService.getUIData('com.playtech.mexos.contract.portal.CampaignProfilePrlObj'),
        )
            .pipe(takeUntil(this._destroy$$), withPreloader(this.preloader), combineLatestAll())
            .subscribe((result) => {
                let fieldSource: UiDataObj = result[0] as UiDataObj;

                this.accountDataService.getCurrentAccount()
                    .pipe(takeUntil(this._destroy$$))
                    .subscribe({
                        next: (account) => {
                            event.fieldsData.next({
                                objectMetaSource: fieldSource,
                                initialData: {
                                    userId: account.id
                                }
                            });
                        },
                    });

            });
        event.addCustomizer(this);
    }

    boOnFormReady(form: FormGroup): void {
        form.setAsyncValidators(this.errorService.asyncValidator(this.prlProfilesCampaignDataService));
        this.form = form;
    }

}
